import React from 'react';
import Loadable from 'react-loadable';

import DefaultLayout from './containers/DefaultLayout';
import { USER_ROLES } from './modules/agent';

const {
  ADMIN,
  SUPER_ADMIN,
  AGENCY
} = USER_ROLES;

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Agencies = Loadable({
  loader: () => import('./containers/Agencies'),
  loading: Loading,
});
const AgencyUpdate = Loadable({
  loader: () => import('./containers/Agencies/Update'),
  loading: Loading,
});
const AgencyView = Loadable({
  loader: () => import('./containers/Agencies/View'),
  loading: Loading,
});

const SubAgencies = Loadable({
  loader: () => import('./containers/SubAgencies'),
  loading: Loading,
});
const SubAgenciesCreate = Loadable({
  loader: () => import('./containers/SubAgencies/create'),
  loading: Loading,
});

const Agents = Loadable({
  loader: () => import('./containers/Agents'),
  loading: Loading,
});

const AgentProfile = Loadable({
  loader: () => import('./containers/Settings/AgentProfile'),
  loading: Loading,
});
const AgencyProfile = Loadable({
  loader: () => import('./containers/Settings/AgencyProfile'),
  loading: Loading,
});

const MailingProfileList = Loadable({
  loader: () => import('./containers/MailingProfile'),
  loading: Loading,
});
const MailingProfileCreate = Loadable({
  loader: () => import('./containers/MailingProfile/Create'),
  loading: Loading,
});
const MailingProfileUpdate = Loadable({
  loader: () => import('./containers/MailingProfile/Update'),
  loading: Loading,
});

const MailingList = Loadable({
  loader: () => import('./containers/MailingList'),
  loading: Loading,
});

const MailPieces = Loadable({
  loader: () => import('./containers/MailPieces'),
  loading: Loading,
});
const MailPiecePreview = Loadable({
  loader: () => import('./containers/MailingList/Preview'),
  loading: Loading,
});

const MailingOrders = Loadable({
  loader: () => import('./containers/MailingOrders'),
  loading: Loading,
});

const Projects = Loadable({
  loader: () => import('./containers/Projects'),
  loading: Loading,
});
const ProjectCreate = Loadable({
  loader: () => import('./containers/Projects/Create'),
  loading: Loading,
});
const ProjectUpdate = Loadable({
  loader: () => import('./containers/Projects/Update'),
  loading: Loading,
});

const Enrollment = Loadable({
  loader: () => import('./containers/Enrollment/Enrollment'),
  loading: Loading
});

const Preview = Loadable({
  loader: () => import('./containers/Preview/Preview'),
  loading: Loading
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', roles: [], component: DefaultLayout },

  { path: '/dashboard', name: 'Dashboard', roles: [], component: Dashboard },

  { path: '/agencies', name: 'Agencies', roles: [SUPER_ADMIN,ADMIN], component: Agencies, exact: true },
  { path: '/agencies/:id/update', name: 'Update', roles: [SUPER_ADMIN,ADMIN], exact: true, component: AgencyUpdate },
  { path: '/agencies/:id/view', name: 'View', roles: [SUPER_ADMIN, ADMIN, AGENCY], exact: true, component: AgencyView },

  { path: '/sub-agencies', name: 'Sub Agencies', roles: [SUPER_ADMIN,ADMIN, AGENCY], component: SubAgencies, exact: true },
  { path: '/sub-agencies/create', name: 'Create', roles: [SUPER_ADMIN, ADMIN, AGENCY], component: SubAgenciesCreate, exact: true },

  { path: '/mailing-profiles', name: 'Mailing Profiles', roles: [SUPER_ADMIN, ADMIN, AGENCY], component: MailingProfileList, exact: true },
  { path: '/mailing-profiles/create', name: 'Create', roles: [AGENCY], component: MailingProfileCreate, exact: true },
  { path: '/mailing-profiles/:id', name: 'Update', roles: [SUPER_ADMIN,ADMIN, AGENCY], component: MailingProfileUpdate, exact: true },

  { path: '/mailing-list', name: 'Mailing List', roles: [SUPER_ADMIN, AGENCY, ADMIN], component: MailingList, exact: true },

  { path: '/mail-pieces', name: 'Mail Pieces', roles: [SUPER_ADMIN, ADMIN, AGENCY], component: MailPieces, exact: true },
  { path: '/mailing-list/:id', name: 'Preview', roles: [SUPER_ADMIN, ADMIN, AGENCY], component: MailPiecePreview, exact: true },

  { path: '/mailing-orders', name: 'Preview', roles: [SUPER_ADMIN,ADMIN, AGENCY], component: MailingOrders, exact: true },

  { path: '/projects', name: 'Projects', roles: [SUPER_ADMIN,ADMIN], component: Projects, exact: true },
  { path: '/projects/create', name: 'Project Create', roles: [SUPER_ADMIN,ADMIN], component: ProjectCreate, exact: true },
  { path: '/projects/:id', name: 'Project Update', roles: [SUPER_ADMIN,ADMIN], component: ProjectUpdate, exact: true },

  { path: '/agents', name: 'Agents', roles: [SUPER_ADMIN], component: Agents },

  { path: '/agent-profile', name: 'Agent Profile', roles: [SUPER_ADMIN, ADMIN, AGENCY], component: AgentProfile },
  { path: '/agency-profile', name: 'Agency Profile', roles: [SUPER_ADMIN, AGENCY], component: AgencyProfile },

  { path: '/enrollment', name: 'Enrollment', roles: [SUPER_ADMIN], component: Enrollment },

  { path: '/preview', name: 'Preview', roles: [AGENCY], component: Preview },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js